module.exports = __webpack_public_path__ + "6571993b917bc3ea6946796111e1e2c6.ttf";


//////////////////
// WEBPACK FOOTER
// ../app/assets/fonts/FuturaLT-Heavy.ttf
// module id = 426
// module chunks = 0